import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import { bindActionCreators } from 'redux';
import SpecializationField from 'profile/components/specialization_field';
import partial from 'lodash/partial';

export function mapStateToProps(state, { input: { name }, meta }) {
  const { profile: { specializations } } = state;
  const selector = formValueSelector(meta.form);
  const specializationValue = selector(state, name);

  return {
    specializationValue,
    specializationOptions: specializations.data,
  };
}

export function mapDispatchToProps(dispatch, { name, meta }) {
  return bindActionCreators({
    onChange: partial(change, meta.form, name),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecializationField);



// WEBPACK FOOTER //
// ./profile/containers/specialization_field.js